<template>
<div class="animated fadeIn">
<div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>Foursight documents</h3>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2"> 
        <div class="col-sm-6">
          <b-form inline>
            <label class="mr-sm-2 d-inline">{{$t('ITEMSPERPAGE')}}</label>
            <b-form-select v-model="pagination.limit" :options="[{value: 25, text: '25'},{value: 50, text: '50'},{value: 100, text: '100'}]"></b-form-select>
          </b-form>
        </div>
        <div class="col-sm-6">
          <b-form-input class="col-sm-3 float-right" v-model="pagination.query" :placeholder="$t('SEARCH')"></b-form-input>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('TITLE')}}</th>
                <th>{{$t('DESCRIPTION')}}</th>
                <th>{{$t('FILE')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in docs.root">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td v-html="item.title"></td>
                  <td v-html="item.description"></td>
                  <td>
                    <b-link :href="item.fileSrc" target="_blank" class="btn-table">View/Download</b-link>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <nav>
            <b-pagination align="center" :total-rows="parseInt(docs.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import DocumentsApi from '@/api/cms/Documents'

export default
{
  name: 'Documents',
  data: function()
  {
    return {
      docs:
      {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.$set(me.pagination, 'categoryId', me.$route.params.categoryId);
    me.getDocs();
  },
  methods:
  {
    async getDocs()
    {
      var me = this;
      try
      {
        var data = await DocumentsApi.selectRow(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.docs = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {
    '$route.params.categoryId': function(val)
    {
      var me = this;
      me.$set(me.pagination, 'categoryId', val);
      me.getDocs();
    },
    'pagination.limit': function(val)
    {
      var me = this;
      me.getDocs();
    },
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getDocs();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getDocs();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
